import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyAccountMe = loadable(() => import(/* webpackChunkName: "content/account/me" */ './AccountMe.route.paths'), 'RouterAccountMe');
